/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * Toggles the state of a filter item in the given state object.
 * If the filter item is active, it will be deactivated and its selected filters will be cleared.
 * If the filter item is inactive, it will be activated.
 * @param state - The state object containing the filter items.
 * @param name - The name of the filter item to toggle.
 * @returns The updated state object with the toggled filter item.
 */
export function toggleFilterState<S extends Record<string, any>>(
  state: S,
  name: string
) {
  const filterSliceState = { ...state };

  const filterItem = filterSliceState.state[name];

  if (!filterItem) {
    return filterSliceState;
  }

  const isActive = !filterItem?.active;

  const updatedFilterSliceState = {
    ...filterSliceState,
    selectedFilters: {
      ...filterSliceState.selectedFilters,
      [name]: !isActive ? [] : filterSliceState.selectedFilters[name],
    },
    state: {
      ...filterSliceState.state,
      [name]: {
        ...filterItem,
        active: isActive,
      },
    },
  };

  return updatedFilterSliceState;
}
